import { render, staticRenderFns } from "./newStarMember.vue?vue&type=template&id=213d4d1c&scoped=true"
import script from "./newStarMember.vue?vue&type=script&lang=js"
export * from "./newStarMember.vue?vue&type=script&lang=js"
import style0 from "./newStarMember.vue?vue&type=style&index=0&id=213d4d1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213d4d1c",
  null
  
)

export default component.exports